import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["input", "corporateName", "corporateNumber", "registratedNumber"];

  connect() {
    this.inputTarget.addEventListener('keyup', this.search.bind(this));
  }

  async search(e) {
    const s = e.target.value;
    const corporateInfoUrl = `https://corporation.teraren.com/corporations.json?s=${s}`;

    try {
      const corporateResponse = await fetch(corporateInfoUrl);
      const { items } = await corporateResponse.json();
      if (items.length === 0) {
        return;
      }
      const [corporateData] = items;

      this.corporateNameTarget.value = corporateData.name;
      this.corporateNumberTarget.value = corporateData.corporate_number;

      const registrationUrl = `https://corporation.teraren.com/invoice_registration_numbers/T${corporateData.corporate_number}.json`;
      const registrationResponse = await fetch(registrationUrl);

      // Corporations without an invoice registration get a 404, so leave the field blank.
      if (!registrationResponse.ok) {
        this.registratedNumberTarget.value = '';
        return;
      }

      const registrationData = await registrationResponse.json();

      this.registratedNumberTarget.value = registrationData.registrated_number;
    } catch (error) {
      console.info(error);
      [this.corporateNameTarget, this.corporateNumberTarget, this.registratedNumberTarget].forEach(target => {
        target.value = '';
      });
    }
  }
}
